import Axios from "axios";
import {
    SET_INV_SALES_INVOICE_DELIVERY_LIST,
    UNSET_INV_SALES_INVOICE_DELIVERY_LIST,
    SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST,
    UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST,
    SET_INV_DELIVERED_SALES_INVOICE_LIST,
    UNSET_INV_DELIVERED_SALES_INVOICE_LIST
} from "@/store/mutation-types";
import {
    getInvSalesInvoiceDeliveryList,
    getInvSalesInvoiceDeliveryById as getInvSalesInvoiceDeliveryByIdApi,
    saveUpdateInvSalesInvoiceDelivery,
    deliveredSalesInvoiceList,
} from "@/store/api";

const state = {
    getInvSalesInvoiceDeliveryList: [],
    editingInvSalesInvoiceDelivery: null,
    deliveredSalesInvoiceList:[],
};

const getters = {
    getInvSalesInvoiceDeliveryList(state) {
        return state.getInvSalesInvoiceDeliveryList;
    },
    getEditingSalesInvoiceDelivery: (state) => {
        return state.editingInvSalesInvoiceDelivery;
    },
    deliveredSalesInvoiceList:(state)=>{
        return state.deliveredSalesInvoiceList;
    }
};

const mutations = {
    [SET_INV_SALES_INVOICE_DELIVERY_LIST](state, data) {
        state.getInvSalesInvoiceDeliveryList = data;
    },
    [UNSET_INV_SALES_INVOICE_DELIVERY_LIST](state) {
        state.getInvSalesInvoiceDeliveryList = [];
    },
    [SET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST](state, data) {
        state.editingInvSalesInvoiceDelivery = data;
    },
    [UNSET_EDITING_INV_SALES_INVOICE_DELIVERY_LIST](state) {
        state.editingInvSalesInvoiceDelivery = null;
    },
    [SET_INV_DELIVERED_SALES_INVOICE_LIST](state, data) {
        state.deliveredSalesInvoiceList = data;
    },
    [UNSET_INV_DELIVERED_SALES_INVOICE_LIST](state) {
        state.deliveredSalesInvoiceList = null;
    },
};

const actions = {
    deliveredSalesInvoiceList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.get(`${deliveredSalesInvoiceList}`, { params: data })
            .then(function (response) {
                commit('SET_INV_DELIVERED_SALES_INVOICE_LIST', response.data.data);
                resolve(response);
            })
            .catch(function (error) {
                commit('UNSET_INV_DELIVERED_SALES_INVOICE_LIST');
                reject(error);
            })
            .then(() => {
                
            })
        })
    },
    saveUpdateInvSalesInvoiceDelivery({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
        Axios.post(saveUpdateInvSalesInvoiceDelivery, data)
            .then(function (response) {
                resolve(response);
            })
            .catch(function (error) {
                reject(error);
            })
            .then((always) => {
                commit("UNSET_LOADING");
            });
        });
    },

    getInvSalesInvoiceDeliveryList({ commit }, data) {
        return new Promise((resolve, reject) => {
            Axios.post(getInvSalesInvoiceDeliveryList, data)
                .then(function (response) {
                    commit("SET_INV_SALES_INVOICE_DELIVERY_LIST", response.data.data);
                    resolve(response);
                })
                .catch(function (error) {
                    commit("UNSET_INV_SALES_INVOICE_DELIVERY_LIST");
                    reject(error);
                })
                .then((always) => {});
            }
        );
    },

    getInvSalesInvoiceDeliveryById({ commit }, id) {
        const getInvSalesInvoiceDeliveryById = `${getInvSalesInvoiceDeliveryByIdApi}/${id}`;
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(getInvSalesInvoiceDeliveryById)
                .then((response) => {
                    resolve(response.data.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .then((always) => {
                    commit("UNSET_LOADING");
                });
            }
        );
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
